import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _blogTag = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _categoryWithTranslations = { coverImage: '_image' };
var _coverMedia = { image: '_image', video: '_video' };
var _getPostPageMetadataRequest = {};
var _getPostPageMetadataResponse = {};
var _getPostPagePreviewRequest = {};
var _getPostPagePreviewResponse = { postPage: '_postPage' };
var _getPostPageRequest = {};
var _getPostPageResponse = { postPage: '_postPage' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _media = { wixMedia: '_wixMedia' };
var _metrics = { averageRating: 'FLOAT' };
var _moderationDetails = {
    submittedDate: 'google.protobuf.Timestamp',
    moderationDate: 'google.protobuf.Timestamp',
};
var _post = {
    firstPublishedDate: 'google.protobuf.Timestamp',
    lastPublishedDate: 'google.protobuf.Timestamp',
    coverMedia: '_coverMedia',
    heroImage: '_image',
    metrics: '_metrics',
    moderationDetails: '_moderationDetails',
    media: '_media',
};
var _postPage = {
    post: '_post',
    categories: '_categoryWithTranslations',
    tags: '_blogTag',
    relatedPosts: '_postPageRelatedPost',
};
var _postPageRelatedPost = { media: '_media' };
var _video = { thumbnail: '_image' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
var _wixMedia = { image: '_image', videoV2: '_videoV2' };
function resolveComWixpressNpmBlogFrontendAdapterPublicV2PostPageServiceUrl(opts) {
    var domainToMappings = {
        'apps._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/blog-frontend-adapter-public',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        _: [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns aggregated data for a post page preview coming from Business Manager. */
export function getPostPagePreview(payload) {
    var _a = serializer(_getPostPagePreviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPostPagePreviewResponse, {
        _blogTag: _blogTag,
        _categoryWithTranslations: _categoryWithTranslations,
        _coverMedia: _coverMedia,
        _image: _image,
        _media: _media,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _post: _post,
        _postPage: _postPage,
        _postPageRelatedPost: _postPageRelatedPost,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __getPostPagePreview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.frontend_adapter_public.v2.post_page',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.blog.frontend.adapter.public.v2.PostPageService.GetPostPagePreview',
            url: resolveComWixpressNpmBlogFrontendAdapterPublicV2PostPageServiceUrl({
                protoPath: '/v2/post-page/preview/{draftPostId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPostPagePreview.fromReq = fromReq;
    __getPostPagePreview.__isAmbassador = true;
    return __getPostPagePreview;
}
/** Returns aggregated data for a post page. */
export function getPostPage(payload) {
    var _a = serializer(_getPostPageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPostPageResponse, {
        _blogTag: _blogTag,
        _categoryWithTranslations: _categoryWithTranslations,
        _coverMedia: _coverMedia,
        _image: _image,
        _media: _media,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _post: _post,
        _postPage: _postPage,
        _postPageRelatedPost: _postPageRelatedPost,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __getPostPage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.frontend_adapter_public.v2.post_page',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.blog.frontend.adapter.public.v2.PostPageService.GetPostPage',
            url: resolveComWixpressNpmBlogFrontendAdapterPublicV2PostPageServiceUrl({
                protoPath: '/v2/post-page/{postId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPostPage.fromReq = fromReq;
    __getPostPage.__isAmbassador = true;
    return __getPostPage;
}
/** Updates and returns metadata for a post (counters). */
export function getPostPageMetadata(payload) {
    var _a = serializer(_getPostPageMetadataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPostPageMetadataResponse, {}).fromJSON;
    function __getPostPageMetadata(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.frontend_adapter_public.v2.post_page',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.blog.frontend.adapter.public.v2.PostPageService.GetPostPageMetadata',
            url: resolveComWixpressNpmBlogFrontendAdapterPublicV2PostPageServiceUrl({
                protoPath: '/v2/post-page-metadata/{postId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPostPageMetadata.fromReq = fromReq;
    __getPostPageMetadata.__isAmbassador = true;
    return __getPostPageMetadata;
}
//# sourceMappingURL=http.impl.js.map